import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { LocalStorageService } from '../services';



export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const token = localStorageService.getItem('token-auth');
  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `bearer ${token}`
      }
    });
    return next(cloned);
  }

  return next(req);
};
